<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialog"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="400px"
      >
        <v-card>
          <v-card-text class="text-xs-center">
            <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="blokaceProblem==null" class="mt-5 mb-2"></v-progress-circular>
            <h3 class="mt-5 mb-3" v-if="blokaceProblem==null">{{aktualni_stav}}</h3>
            <h3 v-else class="mb-3 mt-3 red--text">{{blokaceProblem}}</h3>
            <v-btn color="grey" v-if="blokaceProblem!=null" flat @click="dialog=false">Zavřít</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Přehled produktů k předání</h3>
              </v-flex>
            </v-layout>
            <h3 class="mt-4">Produkty ze spoření</h3>
            <div class="table-border__radius elevation-1 mb-5">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                item-key="row_id"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum | formatSimpleDate }}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                      {{ props.item.nazev_produktu }}
                    </router-link>
                    <div v-if="props.item.darek"><strong>Obsahuje dárek</strong></div>
                  </td>
                  <td>{{ props.item.pocet }}</td>
                  <td :class="{'mw420': $vuetify.breakpoint.smAndUp}">
                    <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-2 pr-2" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndUp}" v-for="(p, n) in props.item.produkty_k_dodani" :key="'rn-'+props.item.row_id.toString()+'-p-'+n.toString()">
                      <v-layout row wrap>
                        <v-flex xs12 sm5 class="d-flex align-center pr-2">
                          {{ p.nazev }}
                        </v-flex>
                        <v-flex xs12 sm3 class="d-flex align-center pr-2">
                          Skladem: {{ p.sklad }} ks
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-layout row class="mt-2">
                            <v-flex xs12>
                              <v-text-field
                                hide-details
                                class="mb-3 mt-0 mx-2"
                                v-model="p.ks"
                                :min="0"
                                suffix="ks"
                                type="number"
                                @input="() => { props.item.problem = null }"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </td>
                  <td>
                    <div class="red--text mb-2" v-if="props.item.problem!=null">{{props.item.problem}}</div>
                    <v-btn color="blue accent-3" v-if="props.item.problem == null"  depressed dark @click="blokovat(props.item)">Blokovat</v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>

            <h3 class="mt-5">Produkty z jednorázových nákupů</h3>
            <div class="table-border__radius elevation-1 mb-5">
              <v-data-table
                :headers="headersJednorazove"
                :items="itemsJednorazove"
                :loading="loadingTableJednorazove"
                :pagination.sync="paginationJednorazove"
                :total-items="paginationJednorazove.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                item-key="row_id"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum | formatSimpleDate }}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    {{props.item.variabilni_symbol}}
                  </td>
                  <td>
                    <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4" v-for="(p, n) in props.item.produkty_k_dodani" :key="'rn-'+props.item.row_id.toString()+'-p-'+n.toString()">
                      <v-layout row wrap>
                        <v-flex xs12 sm5 class="d-flex align-center pr-2">
                          {{ p.nazev }}
                        </v-flex>
                        <v-flex xs12 sm3 class="d-flex align-center pr-2">
                          Objednáno: {{ p.mnozstvi }} ks
                        </v-flex>
                        <v-flex xs12 sm2 class="d-flex align-center pr-2">
                          Skladem: {{ p.sklad }} ks
                        </v-flex>
                        <v-flex xs12 sm2>
                          <v-layout row class="mt-2">
                            <v-flex xs12>
                              <v-text-field
                                hide-details
                                class="mb-3 mt-0 mx-2"
                                v-model="p.ks"
                                :min="0"
                                suffix="ks"
                                type="number"
                                @input="() => { props.item.problem = null }"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </td>
                  <td>
                    <div class="red--text mb-2" v-if="props.item.problem!=null">{{props.item.problem}}</div>
                    <v-btn color="blue accent-3" v-if="props.item.problem == null"  depressed dark @click="blokovatJednorazove(props.item)">Blokovat</v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Datum dospoření', value: 'datum', width: "150px" },
        { text: 'Klient', value: 'nazev_osoby' },
        { text: 'Produkt', value: 'nazev_produktu' },
        { text: 'Počet produktů', value: 'pocet' },
        { text: 'Blokace', value: 'row_id', sortable: false },
        { text: 'Akce', value: '', sortable: false, width: '200px' },
      ],
      headersJednorazove: [
        { text: 'Datum objednávky', value: 'datum', width: "150px" },
        { text: 'Klient', value: 'nazev_osoby' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Blokace', value: 'row_id', sortable: false },
        { text: 'Akce', value: '', sortable: false, width: '200px' },
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      itemsJednorazove: [],
      loadingTableJednorazove: true,
      timeoutJednorazove: null,
      counterJednorazove: 0,
      paginationJednorazove: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        hlavni_cilovy_produkt_id: null,
        mena_id: null
      },
      newItem: null,
      dialog: false,
      blokaceProblem: null,
      aktualni_stav: null
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load(() => {
      this.loadJednorazove(() => {
        this.loading = false;
      });
    });
  },
  watch: {
  	pagination: {
  		handler: function() {
        this.load();
  		},
  		deep: true
  	},
  	paginationJednorazove: {
  		handler: function() {
        this.loadJednorazove();
  		},
  		deep: true
  	},
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load(() => {
          this.loadJednorazove(() => {
            this.loading = false;
          });
        });
      }.bind(this), 200)
    },
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/predani/sporeni/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        for (var i = 0; i < body.data.length; i++)
          body.data[i].problem = null;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadJednorazove: function(f) {
      this.counterJednorazove++;
      this.loadingTableJednorazove = true;
      window.API.post("prehledy/predani/jednorazove-nakupy/search", {
        pagination: this.paginationJednorazove,
        echo: this.counterJednorazove
      }).then(function(body) {
        if (this.counterJednorazove != body.echo)
          return;
        for (var i = 0; i < body.data.length; i++)
          body.data[i].problem = null;
        this.itemsJednorazove.replace(body.data);
        this.paginationJednorazove.sortBy = body.sort.sortBy;
        this.paginationJednorazove.descending = body.sort.descending;
        this.paginationJednorazove.page = body.sort.page;
        this.paginationJednorazove.rowsPerPage = body.sort.rowsPerPage;
        this.paginationJednorazove.totalItems = body.sort.totalItems;
        this.loadingTableJednorazove = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    blokovat (v) {
      var pocet = 0;
      v.produkty_k_dodani.forEach((e) => {
        pocet += !isNaN(e.ks) && parseInt(e.ks) > 0 ? parseInt(e.ks) : 0;
      });
      if (pocet == 0) {
        v.problem = "Nelze blokovat 0 ks";
      }
      else if (pocet > v.pocet) {
        v.problem = "Nelze blokovat větší množství než " + v.pocet.toString();
      }
      var polozky_bez_skladu = 0;
      v.produkty_k_dodani.forEach((e) => {
        if (!isNaN(e.ks) && parseInt(e.ks) > e.sklad)
          polozky_bez_skladu += parseInt(e.ks) - e.sklad;
      });

      if (polozky_bez_skladu > 0) {
        //v.problem = polozky_bez_skladu + " položek není skladem";
      }

      if (v.problem == null) {

        var polozky = v.produkty_k_dodani.filter((e) => {
          return !isNaN(e.ks) && parseInt(e.ks) > 0;
        }).map((e) => {
          return {
            id: e.id,
            ks: parseInt(e.ks)
          };
        });

        this.dialog = true;
        this.blokaceProblem = null;
        this.aktualni_stav = "Probíhá blokace položek na skladě."

        window.API.post("predani-produktu/blokovat", {
          osoba: v.osoba.id,
          typ: "sporeni",
          produkt: v.produkt.id,
          blokovat_polozky: polozky
        }).then(function(body) {
          if (body.created) {
            this.load(() => {
              this.dialog = false;
              this.aktualni_stav = "Produkty byly blokovány.";
            });
          }
          else {
            this.blokaceProblem = "Produkty nebylo možné blokovat."
          }
        }.bind(this)).catch(function(err) {
          this.blokaceProblem = "Produkty nebylo možné blokovat."
          console.log(err);
        }.bind(this));

      }
    },
    blokovatJednorazove (v) {

      var pocet = 0;

      v.produkty_k_dodani.forEach((e) => {
        if (!isNaN(e.ks) && parseInt(e.ks) > e.mnozstvi)
          pocet += parseInt(e.ks) - e.mnozstvi;
      });
      if (pocet > 0) {
        v.problem = "Nelze blokovat větší množství než bylo objednáno";
      }

      var polozky_bez_skladu = 0;
      v.produkty_k_dodani.forEach((e) => {
        if (!isNaN(e.ks) && parseInt(e.ks) > e.sklad)
          polozky_bez_skladu += parseInt(e.ks) - e.sklad;
      });

      if (polozky_bez_skladu > 0) {
        //v.problem = polozky_bez_skladu + " položek není skladem";
      }

      if (v.problem == null) {

        var polozky = v.produkty_k_dodani.filter((e) => {
          return !isNaN(e.ks) && parseInt(e.ks) > 0;
        }).map((e) => {
          return {
            id: e.id,
            ks: parseInt(e.ks)
          };
        });

        this.dialog = true;
        this.blokaceProblem = null;
        this.aktualni_stav = "Probíhá blokace položek na skladě."

        window.API.post("predani-produktu/blokovat", {
          osoba: v.osoba.id,
          typ: "jednorazovy-nakup",
          objednavka: v.id,
          blokovat_polozky: polozky
        }).then(function(body) {
          if (body.created) {
            this.loadJednorazove(() => {
              this.dialog = false;
              this.aktualni_stav = "Produkty byly blokovány.";
            });
          }
          else {
            this.blokaceProblem = "Produkty nebylo možné blokovat."
          }
        }.bind(this)).catch(function(err) {
          this.blokaceProblem = "Produkty nebylo možné blokovat."
          console.log(err);
        }.bind(this));

      }

    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/ProduktyPredani.vue